var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5C10.9703 0.5 0 11.4703 0 25C0 38.5297 10.9703 49.5 24.5 49.5C38.0297 49.5 49 38.5297 49 25C49 11.4703 38.0297 0.5 24.5 0.5ZM24.5 45.3438C13.2672 45.3438 4.15625 36.2328 4.15625 25C4.15625 13.7672 13.2672 4.65625 24.5 4.65625C35.7328 4.65625 44.8438 13.7672 44.8438 25C44.8438 36.2328 35.7328 45.3438 24.5 45.3438Z",
    fill: "#FF4C4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0047 16.25C34.0047 16.0094 33.8078 15.8125 33.5672 15.8125L29.9578 15.8289L24.5219 22.3094L19.0914 15.8344L15.4766 15.818C15.2359 15.818 15.0391 16.0094 15.0391 16.2555C15.0391 16.3594 15.0773 16.4578 15.143 16.5398L22.2578 25.0164L15.143 33.4875C15.0769 33.5676 15.0402 33.668 15.0391 33.7719C15.0391 34.0125 15.2359 34.2094 15.4766 34.2094L19.0914 34.193L24.5219 27.7125L29.9523 34.1875L33.5617 34.2039C33.8023 34.2039 33.9992 34.0125 33.9992 33.7664C33.9992 33.6625 33.9609 33.5641 33.8953 33.482L26.7914 25.0109L33.9062 16.5344C33.9719 16.4578 34.0047 16.3539 34.0047 16.25Z",
    fill: "#FF4C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a6efe1c743f91c2c395043efdb9ea048.svg";
export { ForwardRef as ReactComponent };